
import React, { useState, useContext } from "react";
import { GlobalContext } from "../../App";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import files from "../static";
// import V1 from "../authbg.mp4";
import { HOST } from "../host";
import { logToServer } from "../logger";

export default function KhopoliLogin() {
  const navigate = useNavigate();
  const [member_email, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { setUserInfo, getCsrfToken } = useContext(GlobalContext);
  const [loader, setLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const loginUser = async (e) => {
    e.preventDefault();
    setLoader(true);
    setIsSubmitting(true);

    if (!member_email || !password) {
      toast.warn("Please enter both email and password.");
      setLoader(false);
      setIsSubmitting(false);
      return;
    }
    const formData = {
      member_email: member_email,
      password: password,
    };
    try {
      const res = await fetch(`${HOST}/login/`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": await getCsrfToken(),
        },
      });
      const data = await res.json();
      if (res.status === 400 || res.status === 500 || !data || data.error) {
        toast.error(`${data.error}`);
        logToServer("error", `${data.error}`);
      } else if (res.status === 200) {
        console.log(data.user_info);
        toast.success(`Welcome ${data.user_info.first_name}`);
        logToServer("info", "login Successfully");
        setUserInfo(data.user_info);

        if (data.user_info.org_id === 44 || data.user_info.org_name === "KMC" || data.user_info.org_name === "Khopoli Municipal Council") {
            navigate("/projects");
          } else {
            navigate("/portal");
          }

      }
    } catch (e) {
      logToServer("error", `${e}`);
      toast.error("Invalid credentials");
    } finally {
      setLoader(false);
      setIsSubmitting(false);
    }
  };

  return (
    // <div className="main">
    //   <div className="left-side">
    //     {/* <video src={V1} autoPlay loop muted /> */}
    //     <img
    //         src={`${process.env.PUBLIC_URL}/${files}kmc-bg.png`}
    //         alt="kmc Logo"
    //       />
    //   </div>
    //   <div className="right-side">
    //     <div className="logo">
    //       <img
    //         src={`${process.env.PUBLIC_URL}/${files}KMC_logo.png`}
    //         alt="kmc Logo"
    //       />
    //     </div>
    //     <form className="login-form" style={{ height: "35vh" }}>
    //       <input
    //         style={{ opacity: loader ? "0.3" : "1" }}
    //         value={member_email}
    //         className="mt-3"
    //         onChange={(e) => setUserEmail(e.target.value)}
    //         type="email"
    //         placeholder="name@gmail.com or username123"
    //         required
    //       />
    //       <div className="pass-container">
    //         <input
    //           type={showPassword ? "text" : "password"}
    //           style={{ opacity: loader ? "0.3" : "1" }}
    //           className="type-pass"
    //           value={password}
    //           onChange={(e) => setPassword(e.target.value)}
    //           placeholder="password"
    //           autocomplete="username"
    //           required
    //         />
    //         <button
    //           type="button"
    //           onClick={() => setShowPassword(!showPassword)}
    //         >
    //           {showPassword ? (
    //             <i className="fa fa-eye-slash" title="Hide Password"></i>
    //           ) : (
    //             <i className="fa fa-eye" title="Show Password"></i>
    //           )}
    //         </button>
    //       </div>
    //       <div className="pass-section">
    //         <span
    //           onClick={() => navigate("/forget-password")}
    //           style={{ opacity: loader ? "0.3" : "1" }}
    //           className="reset"
    //         >
    //           Forget password ?{" "}
    //         </span>
    //       </div>
    //       <button
    //         type="submit"
    //         onClick={(e) => loginUser(e)}
    //         className="button"
    //       >
    //         {isSubmitting ? "Signing in..." : " Sign in "}
    //       </button>

    //       <div
    //         onClick={() => navigate("/kmc-signup")}
    //         className="signup-link"
    //         style={{
    //           display: "flex",
    //           justifyContent: "space-between",
    //           alignItems: "center",
    //           width: "100%",
    //         }}
    //       >
    //         <div style={{ textAlign: "left" }}>
    //           Don’t have an account? <span>Sign up</span>
    //         </div>

    //         {loader && (
    //           <div
    //             style={{
    //               position: "relative",
    //               opacity: "1",
    //               zIndex: "1000",
    //               display: "flex",
    //               marginRight: "10%",
    //             }}
    //           >
    //             <div className="lds-dual-ring">
    //               <i className="fa-solid fa-globe"></i>
    //             </div>
    //           </div>
    //         )}
    //       </div>
    //     </form>
    //   </div>
    //   {/* <ToastContainer position="bottom-right" draggable={false} /> */}
    // </div>
    <>
      {/* Blurred background with dark overlay */}
      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/${files}kmc-bg.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(5px)",
          zIndex: 0,
        }}
      ></div>

      {/* Dark overlay on top of the background */}
      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
        }}
      ></div>

      {/* Centered login form */}
      <div
        className="position-fixed top-50 start-50 translate-middle d-flex justify-content-center align-items-center w-100 h-100"
        style={{ zIndex: 2 }}
      >
        <div
          className="bg-light bg-opacity-75 p-5 rounded shadow d-flex flex-column align-items-center"
          style={{
            width: "100%",
            maxWidth: "550px",
            height: "520px", // Portrait shape
          }}
        >
          {/* Bigger logo */}
          <div className="mb-4 text-center">
            <img
              src={`${process.env.PUBLIC_URL}/${files}KMC_logo.png`}
              alt="kmc Logo"
              className="img-fluid"
              style={{ maxHeight: "120px" }}
            />
          </div>

          {/* Login form */}
          <form onSubmit={(e) => loginUser(e)} className="w-100">
            {/* Email field with label */}
            <div className="form-group mb-3">
              <label htmlFor="emailInput" className="form-label fw-semibold">
                Email address
              </label>
              <input
                id="emailInput"
                type="text"
                value={member_email}
                onChange={(e) => setUserEmail(e.target.value)}
                className="form-control p-2"
                placeholder="name@gmail.com or username123"
                required
                style={{ opacity: loader ? "0.3" : "1" }}
              />
            </div>

            {/* Password field with label and toggle icon */}
            <div className="form-group mb-3">
              <label htmlFor="passwordInput" className="form-label fw-semibold">
                Password
              </label>
              <div className="position-relative">
                <input
                  id="passwordInput"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control p-2 pe-5"
                  placeholder="Password"
                  autoComplete="current-password"
                  required
                  style={{ opacity: loader ? "0.3" : "1" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="btn btn-sm position-absolute"
                  style={{
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    border: "none",
                    background: "transparent",
                    padding: "0",
                  }}
                >
                  <i
                    className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                    title={showPassword ? "Hide Password" : "Show Password"}
                  ></i>
                </button>
              </div>
            </div>

            {/* Forgot password link */}
            <div className="mb-3 text-end">
              <span
                onClick={() => navigate("/kmc-forget-password")}
                className="text-primary"
                role="button"
                style={{ opacity: loader ? "0.3" : "1", fontSize: "0.9rem" }}
              >
                Forgot password?
              </span>
            </div>

            {/* Sign in button */}
            <button type="submit" className="btn btn-primary w-100 mb-3">
              {isSubmitting ? "Signing in..." : "Sign in"}
            </button>

            {/* Signup link and loader */}
            <div
              onClick={() => navigate("/kmc-signup")}
              className="d-flex justify-content-between align-items-center"
              role="button"
            >
              <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                Don’t have an account?{" "}
                <span className="text-primary">Sign up</span>
              </div>

              {loader && (
                <div>
                  <div className="spinner-border spinner-border-sm text-primary" />
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
